import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rUstBilgi } from '../../../../api/models/.catalog';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rUstBilgi>, rUstBilgi>(
  ActionSubTypes.API_GRUPSIRKETIUSTBILGI,
  DefaultInputDataStateModel<pList, rUstBilgi>()
);
